import { IAppState, INMEASource } from "../Types"

export enum GPSPrecision {
  reduced = 1,
  high = 2,
}

export function gpsPrecision(app: Pick<IAppState, "status">): GPSPrecision | undefined {
  switch (app.status?.nmea.data.navigation?.source) {
    case INMEASource.native: return GPSPrecision.reduced;
    case INMEASource.nmea: return GPSPrecision.high;
    default: return undefined;
  }
}

export function supportsGPSPrecision(app: Pick<IAppState, "status">, minimum: GPSPrecision): boolean {
  const precision = gpsPrecision(app);
  return precision == undefined || precision >= minimum;
}
